import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { useThemeStore } from '../../../stores/useThemeStore';
import logoLight from '../../../assets/MainLogo/MKraftLogoLight.png';
import logoDark from '../../../assets/MainLogo/MKraftLogoDark.png';
import './VerifyOTP.css';

const VerifyOTP: React.FC = () => {
  const navigate = useNavigate();
  const { theme } = useThemeStore();
  const [otp, setOtp] = useState<string[]>(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(165); // 2:45 = 165 seconds

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleOtpChange = (index: number, value: string) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto-focus next input
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput?.focus();
      }
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      prevInput?.focus();
    }
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')} Seconds`;
  };

  const handleVerify = () => {
    console.log('OTP:', otp.join(''));
    // Navigate to create new password page without validation
    navigate('/create-new-password');
  };

  const handleResend = () => {
    setTimer(165);
    setOtp(['', '', '', '', '', '']);
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  // Select logo based on theme
  const logo = theme === 'dark' ?  logoDark : logoLight;

  return (
    <div className="verify-otp-container">
      <div className="verify-otp-header">
        <div className="verify-otp-logo">
          <img src={logo} alt="Multiplierskraft Logo" className="verify-otp-logo-image" />
        </div>
      </div>

      <div className="verify-otp-card">

        <h1 className="verify-otp-title">Verify OTP</h1>
        <p className="verify-otp-subtitle">Please check your registered email.</p>

        <div className="verify-otp-otp-section">
          <p className="verify-otp-otp-instruction">
            Please enter the OTP received via <strong>Prince.p@multiplierskraft.com</strong>
          </p>

          <div className="verify-otp-otp-inputs">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength={1}
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="verify-otp-otp-input"
              />
            ))}
          </div>

          <div className="verify-otp-timer">{formatTime(timer)}</div>
        </div>

        <button
          type="button"
          className="verify-otp-verify-btn"
          onClick={handleVerify}
        >
          Verify OTP
        </button>

        <p className="verify-otp-resend-text">
          Didn't receive the code?{' '}
          <button
            type="button"
            className="verify-otp-resend-link"
            onClick={handleResend}
          >
            Resend OTP.
          </button>
        </p>
      </div>
    </div>
  );
};

export default VerifyOTP;
